export default __webpack_public_path__ + "static/media/next.ac544241.svg";